import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddAdminComp from './AddAdmin';

import { CommonModelImpl } from '../../admin/common/CommonModel';
import SideBar from '../../admin/common/sideBar';
import NoData from '../../admin/common/NoData';

import HeaderAdminpanel from "../common/HeaderAdminpanel"; 
import http from '../../../util/http';
import { getAdminData } from '../../../util/util';
import { endPoints } from '../../../config';
import { getServerDataWithTypes } from '../../../action/common_action';
import { ADMINS_DATA, ANY_ERROR } from '../../../action/user_action_types';
import moment from 'moment';

class AdminComp extends Component {
  constructor(props) {
    super(props);
    //Set initial state
    this.state = {
      adminData: getAdminData(),
      adminsData: [], totalRecord: 0,
      currentAdmin: {}, searchName: "",
      showDeletePopup: false, msg: "",
      showAddAdminPopup: false,
      page: 1, skip: 0, limit: 10,
    };
  };

  //Fetch all admin
  getAllData= skip=> {
    let { limit }= this.state;
    let page= (skip / limit) + 1;
    this.setState({page}, ()=> {
      this.componentDidMount();
    });
  }

  //make a call to fetch admin
  componentDidMount = () => {
    let { page } = this.state;
    let url = `${endPoints.getAdminsData}?page=${page}`;
    this.props.getAdminsData(url, ADMINS_DATA);

  }

  //Set data of admin to state
  componentWillReceiveProps = nextProps => {
    let { adminsData } = nextProps;
    if (adminsData) {
      let { allData, count } = adminsData;
      this.setState({
        adminsData: allData ? allData : [],
        totalRecord: count ? count : 0
      });
    }
  }

  //Adding admin
  addAdmin= (data)=> {
    this.serverCalls(endPoints.addAdmin, data);
    this.showHideAddAdminPopup();
  }

  //Delete a admin
  deleteAdmin = () => {
    let { currentAdmin } = this.state;
    let { _id } = currentAdmin;
    let data = { _id };
    this.serverCalls(endPoints.deleteAdmin, data);
    this.setState({
      page: 1,
      currentAdmin: {},
      msg: "",
      showDeletePopup: false
    });
  };

  //Making an http request
  serverCalls= async(url, data)=> {
    const response= await http.post(url, data);
    if(response && response.data.statusCode== 200) {
      this.componentDidMount();
    }
    else {
      this.props.showError(response? response.data.message: "Something is wrong");
    }
  }

  //Show hide delete popup
  showHideDeletePopup = currentAdmin => {
    let { adminData }= this.state;
    if(currentAdmin && currentAdmin.email== adminData.email) {
      return this.props.showError('You can not delete yourself!');
    }
    this.setState({
      currentAdmin: currentAdmin ? currentAdmin : {},
      msg: currentAdmin? "Are you sure you want to delete this admin?": "",
      showDeletePopup: !this.state.showDeletePopup
    });
  };

  //Show hide add admin popup
  showHideAddAdminPopup= ()=> {
    this.setState({
      showAddAdminPopup: !this.state.showAddAdminPopup
    });
  }

  //Admin logout
  logout = () => {
    localStorage.removeItem('adminInfo');
    window.location.href = '/admin/login';
  }

  render() {
    let { adminsData, totalRecord, adminData, searchName, showDeletePopup, msg,
      skip, showAddAdminPopup } = this.state;
    return (
      <div>
        <div className="dashboardContainer">
        <HeaderAdminpanel/>
          <div className="dashboardContainer-inner">
            <section id="sidebar">
              <SideBar parent="0" child="0"/>
            </section>
            <section id="dashboard-rightContainer" className="dashboard-manageSales">
              <div className="container-head">
                <div className="dashboard-breadcrumb">System Configuration |<span className="breadcrumb-active advertiser-breadcrumb">Admin List</span></div>

                <div className="search_camp">
                  <button onClick={this.showHideAddAdminPopup} className="search_camp_btn">ADD</button>
                </div>
              </div>

              <div className={adminsData.length === 0 ? "dashboard-content userListing-dashboard bg-white table-responsive none" : "dashboard-content userListing-dashboard bg-white table-responsive"}>
                <table className="table table-striped master-table">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Cluster</th>
                      <th>Last Login</th>
                      <th>Last Active Session</th>
                      <th className="txt-cntr">Actions</th>
                    </tr>
                  </thead>
                  <tbody>

                    {adminsData.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{data.email}</td>
                          <td>{data.role}</td>
                          <td>{data.cluster}</td>
                          <td>{data.lastLogin && <span>{moment(data.lastLogin).format("DD/MM/YYYY hh:mm A")}</span>}
                              {!data.lastLogin && <span>NA</span>}
                          </td>
                          <td>{ data.lastActiveSession ? (<span>{moment(data.lastActiveSession).format("DD/MM/YYYY hh:mm A")}</span>) : (<span>NA</span>) } </td>
                          <td className="txt-cntr">
                            <a>
                              <span className="tooltip-reject">
                                <img src="/assets/images/delete.png" className="reject-approved-img reject-png"
                                  onClick={()=> this.showHideDeletePopup(data)} />
                                <span>Delete</span>
                              </span>
                            </a>
                          </td>
                        </tr>
                      )
                    })}

                  </tbody>
                </table>
                <div className="paginationTable" />
                {/* {(skip > 0 || totalRecord > 10) &&
                  <Pagination getAllData={this.getAllData} totalRecords={totalRecord} />
                } */}
              </div>

              {adminsData.length === 0 ?
                <NoData /> : null}
            </section>
          </div>
        </div>
        {showDeletePopup &&
          <CommonModelImpl
            headerMsg={"Admin Delete"}
            msg={msg}
            okButtonShow={true}
            okButtonText={"PROCEED"}
            okAction={this.deleteAdmin}
            cancelButtonShow={true}
            cancelButtonText={"No"}
            cancelAction={this.showHideDeletePopup}
          />
        }
        {showAddAdminPopup &&
          <AddAdminComp
            addAdmin= {this.addAdmin}
            hidePopup= {this.showHideAddAdminPopup}
          />
        }      </div>
    )
  }

}

const mapStateToProps = state => {
  return {
    adminsData: state.user.get("adminsData")
  }
};

const mapDispatchToProps = dispatch => {
  return {
    getAdminsData: (url, type) => dispatch(getServerDataWithTypes(url, type)),
    showError: error=> dispatch({
      type: ANY_ERROR,
      payload: error
    })
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminComp);



// WEBPACK FOOTER //
// ./web/components/admin/admin_management/AdminComp.jsx